<template>
  <div>
    <img class="card_image" :src="src" />
    <div class="card_content">
      <div class="hide_overlay">
        <div class="card_divider ml-1"></div>
      </div>
      <div class="hide_overlay">
        <div class="card_destination">{{ data.subtitle }}</div>
      </div>
      <div class="hide_overlay">
        <div class="card_location">
          {{ data.title | capitalize }}
        </div>
      </div>
      <div class="hide_overlay">
        <div class="description">
          {{ data.description }}
        </div>
      </div>
      <div class="hide_overlay">
        <div class="link_btn mt-3">
          <v-btn outlined rounded color="white" @click="handleCardButton"
            >Discover more...</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCard',
  props: {
    data: { type: Object }
  },
  data() {
    return { src: '', showDescription: false }
  },
  watch: {
    $props: {
      handler() {
        this.src = this.data.src
      },
      deep: true,
      immediate: true
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      return value.toUpperCase()
    }
  },
  methods: {
    handleCardButton() {
      if (this.data.routeType === 'videos') {
        this.$router.push({
          name: 'videos',
          query: { category: this.data.routeParam.category }
        })
      } else {
        this.$router.push({
          name: 'video-page',
          query: this.data.routeParam
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card_image {
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.card_content {
  color: white;
  position: absolute;
  top: 60%;
  margin: 0 0 0 1rem;
}

.card_divider {
  width: 1.2rem;
  border-bottom: 2px solid white;
}
.grow .card_divider {
  animation: slide 0.9s ease;
}

.card_destination {
  margin: 0.5rem 0 0 0;
  font-size: 1.3rem;
}
.grow .card_destination {
  font-size: 2rem;
  transition: font-size 0s 0.5s;
  animation: slide 1s ease;
}
.full .card_destination {
  font-size: 2rem;
}

.card_location {
  font-size: 2.7rem;
  font-weight: 600;
  line-height: 1.2;
}
.grow .card_location {
  font-size: 5rem;
  transition: font-size 0s 0.5s;
  animation: slide 1.1s ease;
}
.full .card_location {
  font-size: 5rem;
}

@keyframes slide {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(100px);
  }
  100% {
    transform: translateY(0px);
  }
}

.hide_overlay {
  overflow: hidden;
}

.description {
  display: none;
  font-size: 1.2rem;
  font-weight: 300;
}
.grow .description {
  display: block;
  animation: slide_up_hidden_content 1.2s ease;
}
.full .description {
  display: block;
}

.link_btn {
  display: none;
  font-size: 1.2rem;
}
.grow .link_btn {
  display: block;
  animation: slide_up_hidden_content 1.3s ease;
}
.full .link_btn {
  display: block;
}

@keyframes slide_up_hidden_content {
  0% {
    transform: translateY(250px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
